import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import { useRegions } from '@/data/region';
import LoadingPage from '@/components/common/LoadingPage';

import AddRegionDialog from './list/AddRegionDialog';
import RegionList from './list/RegionList';

const ListPage = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center mb-4">
          Regions <AddRegionDialog />
        </CardTitle>
        <CardDescription>
          Set up coach regions. A region is an area that a coach might want to
          teach at a few different location. Like &quot;The Okanagan&quot; or
          &quot;The Lower Mainland&quot; for example.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <RegionList />
      </CardContent>
    </Card>
  );
};

const ListPageLoader = () => {
  const regions = useRegions();

  if (regions.isLoading && !regions.data) {
    return <LoadingPage />;
  }

  return <ListPage />;
};

export default ListPageLoader;
